import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useBlogsList() {
    // Use toast
    const toast = useToast();

    const refBlogListTable = ref(null);

    // Table Handlers
    let tableColumns = [
        { key: 'title', sortable: true, label: 'Título' },
        { key: 'author', sortable: true, label: 'Autor' },
        { key: 'shortDescription', sortable: true, label: 'Descripción' },
        { key: 'tags', sortable: false, label: 'Etiqueta(s)' },
        { key: 'dateFormatted', sortable: true, label: 'Fecha de Publicación' },
        { key: 'active', sortable: true, label: 'Estado' },
        { key: 'actions', label: 'Opciones' }
    ];

    const perPage = ref(10);
    const totalBlogs = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const sortBy = ref('createdAt');
    const isSortDirDesc = ref(false);

    const rangePickerFilter = ref(null);
    const statesFilter = ref(null);

    const dataMeta = computed(() => {
        const localItemsCount = refBlogListTable.value ? refBlogListTable.value.localItems.length : 0;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalBlogs.value,
        }
    });

    const refetchData = () => {
        refBlogListTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery, rangePickerFilter, statesFilter], () => {
        refetchData();
    });

    const fetchBlogs = (ctx, callback) => {
        store
            .dispatch('app-blog/fetchBlogs', {
                q: searchQuery.value,
                perPage: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,

                range: rangePickerFilter.value,
                states: statesFilter.value,
            })
            .then(response => {
                const { blogs, total } = response.data;
                callback(blogs);
                totalBlogs.value = total;
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error al obtener la lista de blogs',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger'
                    }
                });
            })
    };

    return {
        fetchBlogs,
        tableColumns,
        perPage,
        currentPage,
        totalBlogs,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refBlogListTable,

        refetchData,

        // Extra Filters
        rangePickerFilter,
        statesFilter
    }
}